import type { PropsWithChildren, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Card from '@/components/Card';
import LoopingEllipsis from '@/components/LoopingEllipsis';
import IconButton from '@/components/IconButton';
import { DownloadIcon, InfoIcon } from '@/icons';
import Tooltip from '@/components/Tooltip';
import { classes } from './utils';

export interface OverviewCardProps extends PropsWithChildren {
  isFetchingData?: boolean;
  className?: string;
  bodyClassName?: string;
  title: string;
  subtitle?: string | null;
  actions?: ReactNode;
  onInfo?: () => void;
  onExport?: () => void;
}

export default function OverviewCard({
  isFetchingData,
  className,
  bodyClassName,
  title,
  subtitle,
  actions,
  onInfo,
  onExport,
  children,
}: OverviewCardProps) {
  return (
    <Card className={twMerge(classes.card, className)}>
      <div className={classes.titleWrapper}>
        <div>
          <h1 className={classes.title}>{title}</h1>
          {subtitle && <h4 className={classes.subtitle}>{subtitle}</h4>}
        </div>
        <div className={classes.buttonsWrapper}>
          {actions}
          {onInfo && <InfoIcon className={classes.infoIcon} onClick={onInfo} />}
          {onExport && (
            <Tooltip title="Export">
              <IconButton className={classes.exportIcon} onClick={onExport}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
      <div className={twMerge(classes.body, bodyClassName)}>
        {isFetchingData ? (
          <div className={classes.loadingMessage}>
            Fetching report
            <LoopingEllipsis />
          </div>
        ) : (
          children
        )}
      </div>
    </Card>
  );
}
